<template>
	<el-dialog :close-on-click-modal="false" :title="showTitle" :visible.sync="dialogAddShow" width="60%"
		:before-close="handleClose">
		<el-form :rules="userRules" label-position="right" ref="addForm" :model="addForm" label-width="70px"
			class="postForm">
			<el-form-item label="登录名:" label-width="150px" prop="adminAccount" class="notBlank">
				<el-input v-model="addForm.adminAccount" auto-complete="off" class="formItem" size="small" :disabled="addForm.adminID>0"/>
			</el-form-item>
			<el-form-item label="姓名:" label-width="150px" prop="adminName" class="notBlank">
				<el-input v-model="addForm.adminName" auto-complete="off" class="formItem" size="small" />
			</el-form-item>
			<el-form-item label="密码:" label-width="150px" prop="adminPassword" v-show="addForm.adminID==0"
				class="notBlank">
				<el-input v-model="addForm.adminPassword" show-password auto-complete="off" class="formItem"
					size="small" />
			</el-form-item>
			<el-form-item label="超级管理员:" label-width="150px" prop="isSuperAdmin">
				<el-checkbox v-model="addForm.isSuperAdmin" :true-label="1" :false-label="0" size="small"></el-checkbox>
			</el-form-item>
			<el-form-item label="角色:" label-width="150px" prop="roleIDs" class="notBlank" v-if="!addForm.isSuperAdmin">
				<el-select v-model="addForm.roleIDs" placeholder="请选择" size="small">
					<el-option v-for="item in roleIDsDict" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="新增数据权限:" label-width="150px" prop="accessAdd" v-if="1==2">
				<el-checkbox v-model="addForm.accessAdd" :true-label="1" :false-label="0" size="small"></el-checkbox>
			</el-form-item>
			<el-form-item label="修改数据权限:" label-width="150px" prop="accessMod" v-if="1==2">
				<el-checkbox v-model="addForm.accessMod" :true-label="1" :false-label="0" size="small"></el-checkbox>
			</el-form-item>
			<el-form-item label="删除数据权限:" label-width="150px" prop="accessDel" v-if="1==2">
				<el-checkbox v-model="addForm.accessDel" :true-label="1" :false-label="0" size="small"></el-checkbox>
			</el-form-item>
			<el-form-item label="管理部门:" label-width="150px"  v-if="1==2">
				<el-tree :data="deptDict" show-checkbox node-key="id" ref="tree" highlight-current :props="defaultProps"  :default-expanded-keys="defaultExpandedKeys"></el-tree>
			</el-form-item>
			<el-form-item label="管理操作员:" label-width="150px" prop="mangeAdminIds"  v-if="1==2">
				<el-select v-model="mangeAdminIds" multiple size="small" style="width:80%;"
					placeholder="请选择">
					<el-option v-for="item2 in mangeUserList" :key="item2.adminID"
						:label="item2.adminName" :value="String(item2.adminID)">
					</el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose()" size="small">取 消</el-button>
			<el-button type="primary" @click="handleSubmit()" size="small">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
	export default {
		name: "addSave",
		props: ["showTitle", "dialogAddShow", "mid"],
		data() {
			const validateadminAccount = (rule, value, callback) => {
				if (value.length == 0 && !value) {
					callback(new Error("登录名不能空"));
				} else {
					callback();
				}
			};
			return {
				addForm: {},
				roleIDsDict: [],
				 userRules: {
					/* adminAccount: [{required: true,message: "00000",trigger: "blur"}] */
				},
				mangeAdminIds:[], 
				mangeUserList:[],
				deptDict: [],
				defaultProps: {
					children: "children",
					label: "deptName"
				},
				defaultExpandedKeys: []
			};
		},
		watch: {
			dialogAddShow: {
				handler(newVal, oldVal) {
					if (newVal) {
						this.mangeUserList=[]
						this.mangeEmpIds=[]
						this.loadUserList()
						//this.loadDict()
						this.initData()
					}
				},
				deep: true
			}
		},
		methods: {
			getTreeData() {
				this.deptDict = [{ "id": 0, deptName: "所有部门", children: [] }]
				// let formData = this.$util.jsonToForm({
				// 	id: 0,
				// 	parentId: 0,
				// 	sortNum: 0,
				// 	"isDrag": 0,
				// });
				// this.$axios.post("/sys/getsys_departmentlist", formData).then(res => {
				// 	this.deptDict = [{ "id": 0, deptName: "所有部门", children: res.data.data }]
				// });
			},
			initData() {
				this.$axios.get("/backadmin/geteslrecordinfo?id=" +this.mid +"&rnd=" +new Date().getTime())
					.then(res => {
						this.addForm = res.data.data;
						if(this.addForm.roleIDs=="") this.addForm.roleIDs=0;
						else this.addForm.roleIDs=parseInt(this.addForm.roleIDs);
						// if(this.addForm.mangeEmpIds && this.addForm.mangeEmpIds!=''){
						// 	this.mangeEmpIds=this.addForm.mangeEmpIds.split(',')
						// }
						// this.$refs.tree.setCheckedKeys(this.addForm.mangeDeptIds.split(','))
	
					});
			},
			loadUserList(){
				let formData = this.$util.jsonToForm({
					adminName: '',
					isSuperAdmin:0,
					rows:1000,
					page:1,
				});
				this.$axios.post("/backadmin/geteslrecordlist",formData).then(res=>{
					this.mangeUserList=res.data.data;
				});
			},
			loadDict() {
				this.$axios
					.get("/comm/geteslroledict?rnd=" + new Date().getTime())
					.then(res => {
						this.roleIDsDict = res.data.data;
					});
			},
			handleClose() {
				this.$emit("getVisible", false);
			},
			selEmpCallback(data){
				this.$set(this.addForm, "empId", data.valuekey)
				this.$set(this.addForm ,"empName", data.textkey)
			},
			handleSubmit() {
				this.$refs.addForm.validate(valid => {
					if (valid) {
						var nodes =[]// this.$refs.tree.getCheckedNodes();
						var deptIds = [];
						nodes.forEach(function(item) {
							 deptIds.push(item.id);
						});
						this.addForm.manageDeptIds=deptIds.join(',')
						this.addForm.mangeAdminIds=this.mangeAdminIds.join(',')
						let formData = this.$util.jsonToForm(this.addForm);
						formData.append("txt_id", this.addForm.adminID);
						this.$axios.post("/backadmin/eslrecordsave", formData).then(res => {
							if (res.data.status == 0) {
								//this.$refs.addForm.resetFields() // 表单重置
								this.$message("保存成功!");
								this.$emit("saveCallBack");
							} else {
								this.$message(res.data.msg);
							}
						});

					} else {
						return false;
					}
				});
			},
			getDefaultExpandedKeys() {
				const getFirstLevelKeys = (data) => {
					return data.map(item => item.id);
				};
			this.defaultExpandedKeys = getFirstLevelKeys(this.deptDict);
			}
		},
		created(){
			this.loadDict();
			this.getTreeData()
		},
		mounted() {
			this.getDefaultExpandedKeys();
		},
	};
</script>

